import jquery from 'jquery';
global.$ = jquery;

import "pixi-spine";
import "../../libs/p3.min";
import Main from './Main';

const main = new Main(1024, 768);
main.init();